import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=36b3dfce&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=36b3dfce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3dfce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b3dfce')) {
      api.createRecord('36b3dfce', component.options)
    } else {
      api.reload('36b3dfce', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=36b3dfce&scoped=true&", function () {
      api.rerender('36b3dfce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2go3VxX00tbNj/JS/comp/CookieBox.vue"
export default component.exports